import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { TableHeader } from 'components/table/table-content';
import { Filters } from 'elements/Filter';
import { PubSub } from 'lib/event/PubSub';
import { FilterManager } from 'lib/tables/FilterManager';
import { AsyncErrorHandler } from 'lib/ui';
import { PenPipeSizeDto } from 'models/pen/PenPipeSize';
import { PenPipeSizeService } from 'services/pen/pen-pipe-size-service';

@autoinject
export class PenPipeSizeList {
  protected tableData: Array<PenPipeSizeDto>;
  protected activeTableRow: number;

  protected tableHeaders: TableHeader<PenPipeSizeDto>[] = [{ key: 'Name', label: 'general.name', sortable: true }];

  constructor(
    private eventAggregator: EventAggregator,
    private penPipeSizeService: PenPipeSizeService,
    protected fm: FilterManager,
    private pubsub: PubSub,
    private router: Router
  ) {
    pubsub.sub('filter-manager:filter-changed', () => {
      this.updateView();
    });
  }

  protected async attached() {
    this.eventAggregator.subscribe('penPipeSizesReset', () => {
      this.activeTableRow = null;
      return this.updateView();
    });

    this.fm.init({
      context: 'pen-pipe-size-list',
      storageKey: 'pen-pipe-size-list',
      filters: {
        //TODO
      } satisfies Filters,
      defaultFilters: {
        //TOD
      },
    });

    this.updateView();
  }

  @AsyncErrorHandler
  async updateView() {
    const response = await this.penPipeSizeService.getPenPipeSizes(this.fm.queryFilter);

    if (!response) return;
    this.fm.paginationTotalRecords = +response.headers.get('x-total-count') || 0;

    this.tableData = response.data;
  }

  protected setOrderByColumn(column: string) {
    this.fm.setOrderByColumn(column);
  }

  protected gotoDetailView(id: number) {
    this.activeTableRow = id;
    this.router.navigateToRoute('pen-pipe-size-detail', { Id: id });
  }

  protected detached() {
    this.pubsub.unsub();
  }

  protected unbind() {
    this.pubsub.unsub();
  }
}
